module.exports = __webpack_public_path__ + "assets/img/11.3d1b9d54.png";